// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cu-page {
  --cu-type-heading: clamp(2.1rem, 2.8vw, 2.8rem);
  --cu-type-subheading: 1.5rem;
  --cu-type-card-heading: 1.2rem;
  --cu-type-body: 1.05rem;
  --cu-type-label: 0.92rem;
  --cu-type-cta: 1.02rem;
  background: #ece4ed;
  min-height: 100vh;
  padding: 2.5rem 0 4rem;
  color: #400C4D;
}

.cu-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.cu-hero {
  text-align: center;
  padding-bottom: 2rem;
}

.cu-hero__title {
  font-size: var(--cu-type-heading);
  font-weight: 800;
  margin-bottom: 0.5rem;
  font-family: "Lexend", system-ui, sans-serif;
  color:#400C4D;
}

.cu-hero__subtitle {
  margin: 0 auto;
  max-width: 640px;
  line-height: 1.6;
  color: #4a4f65;
  font-size: var(--cu-type-body);
}

.cu-quick {
  margin: 2rem 0 3rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.cu-socialLinks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: -1.75rem 0 2rem;
}

.cu-socialLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.9rem;
  border-radius: 999px;
  border: 1px solid #400C4D;
  background: #d6c3d9;
  color: #400C4D;
  text-decoration: none;
  font-weight: 700;
  font-size: var(--cu-type-label);
}

.cu-socialLink:hover {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #1f2937;
  text-decoration: none;
}

.cu-quickCard {
  background: #d6c3d9;
  border-radius: 14px;
  padding: 1rem 1.15rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #400C4D;
  text-decoration: none;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.06);
  border: 1px solid #400C4D

}

.cu-quickIcon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #F6EEF8;
  display: grid;
  place-items: center;
  font-size: 1.35rem;
  color: #400C4D;
}

.cu-quickIcon--green {
  background: #ebf7f0;
  color: #0f9d58;
}

.cu-quickText {
  display: flex;
  flex-direction: column;
}

.cu-quickSmall {
  font-size: 0.85rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #637094;
}

.cu-quickBold {
  font-weight: 700;
  font-size: 1.08rem;
}

.cu-quickBold--green {
  color: #0f9d58;
}

.cu-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 2rem;
}

.cu-formCard,
.cu-right {
  background: #ffffff;
  border-radius: 18px;
  padding: 2rem;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.08);
}

.cu-formHead {
  margin-bottom: 1.5rem;
}

.cu-formTitle {
  margin: 0;
  font-size: var(--cu-type-subheading);
  font-weight: 800;
}

.cu-formSub {
  margin: 0.4rem 0 0;
  color: #56617e;
  font-size: var(--cu-type-body);
}

.cu-formFallback {
  margin: 0.5rem 0 0;
  color: #b91c1c;
  font-size: 1rem;
  font-weight: 700;
}

.cu-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cu-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.cu-label {
  font-size: var(--cu-type-label);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #637094;
}

.cu-input,
.cu-textarea {
  border: 1px solid #dfe5f3;
  border-radius: 12px;
  padding: 0.85rem 1rem;
  font-size: var(--cu-type-body);
  font-family: inherit;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.cu-input:focus,
.cu-textarea:focus {
  outline: none;
  border-color: #400C4D;
  transform: translateY(-1px);
}

.cu-textarea {
  min-height: 160px;
  resize: vertical;
}

.cu-row2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.cu-btnPrimary {
  background: #400C4D;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 0.85rem 1.3rem;
  font-weight: 700;
  font-size: var(--cu-type-cta);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cu-btnPrimary--link {
  text-decoration: none;
  width: fit-content;
  margin-top: 0.7rem;
}

.cu-btnPrimary:hover {
  transform: translateY(-2px);
  color: #f59e0b;
  box-shadow: 0 15px 25px rgba(64, 12, 77, 0.35);
}

.cu-btnPrimary:disabled {
  cursor: not-allowed;
  opacity: 0.7;
  transform: none;
  box-shadow: none;
}

.cu-sendIcon {
  font-size: 1rem;
}

.cu-submitMsg {
  margin: 0;
  font-weight: 600;
}

.cu-submitMsg--success {
  color: #15803d;
}

.cu-submitMsg--error {
  color: #b91c1c;
}

.cu-right {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cu-map {
  border-radius: 18px;
  box-shadow: 0 25px 40px rgba(15, 23, 42, 0.15);
  overflow: hidden;
  padding: 0;
  background: #fefefe;
  border: 1px solid rgba(15, 23, 42, 0.05);
}

.cu-map iframe {
  width: 100%;
  border: none;
  min-height: 220px;
  display: block;
}

.cu-mapBtn {
  background: #400C4D;
  color: white;
  border: none;
  border-radius: 999px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  cursor: pointer;
  margin: 1rem 1.5rem;
  align-self: flex-start;
  transition: background 0.2s ease;
}

.cu-mapBtn:hover {
  background: #2A0733;
}

.cu-centers {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cu-centersTitle {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: 700;
  font-size: var(--cu-type-card-heading);
}

.cu-centerCard {
  border-radius: 18px;
  padding: 1.3rem;
  border: 1px solid #e4e7ef;
  background: #fdfdfd;
  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.06);
}

.cu-centerCard--primary {
  border-color: rgba(122, 42, 133, 0.35);
}

.cu-centerCard--accent {
  border-color: rgba(244, 143, 177, 0.4);
}

.cu-centerTop {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.9rem;
}

.cu-centerName {
  font-weight: 800;
  font-size: 1.08rem;
}

.cu-tag {
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
  font-size: 0.85rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.cu-tag--primary {
  background: rgba(122, 42, 133, 0.12);
  color: #400C4D;
}

.cu-tag--accent {
  background: rgba(244, 143, 177, 0.18);
  color: #cb1f72;
}

.cu-infoRow {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
  color: #616a85;
  font-size: var(--cu-type-body);
}

.cu-infoRow span:first-child {
  color: #400C4D;
}

.cu-cta {
  margin-top: 3rem;
  position: relative;
  background: #400C4D;
  border-radius: 28px;
  padding: 3rem 1rem 2rem;
  overflow: hidden;
  color: #fff;
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.35);
}

.cu-ctaGlow {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  opacity: 0.25;
}

.cu-ctaGlow--left {
  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.5), transparent 55%);
}

.cu-ctaGlow--right {
  background: radial-gradient(circle at 75% 30%, rgba(255, 255, 255, 0.35), transparent 60%);
}

.cu-ctaInner {
  position: relative;
  max-width: 960px;
  margin: 0 auto;
}

.cu-ctaInner h2 {
  margin: 0;
  font-size: clamp(2rem, 3vw, 2.6rem);
  font-weight: 900;
  color: #ffffff;
}

.cu-ctaInner p {
  margin: 0.75rem 0 1.5rem;
  max-width: 600px;
  line-height: 1.6;
  color: #ffffff;
}

.cu-ctaActions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.cu-ctaPrimary,
.cu-ctaGhost {
  border-radius: 999px;
  padding: 0.9rem 1.8rem;
  font-weight: 700;
  font-size: var(--cu-type-cta);
  cursor: pointer;
  border: none;
  transition: transform 0.2s ease;
}

.cu-ctaPrimary {
  background: #fff;
  color: #400C4D;
}

.cu-ctaGhost {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.55);
  color: #fff;
  text-decoration: none;
}

.cu-ctaPrimary:hover,
.cu-ctaGhost:hover {
  transform: translateY(-2px);
  color: #f59e0b;
}

@media (max-width: 1024px) {
  .cu-main {
    grid-template-columns: 1fr;
  }
  .cu-row2 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .cu-spotlight,
  .cu-ctaInner {
    padding: 0 1rem;
  }
}

html[data-theme="dark"] .cu-page {
  background: #02030a;
  color: #f8fafc;
}

html[data-theme="dark"] .cu-hero__subtitle,
html[data-theme="dark"] .cu-formSub,
html[data-theme="dark"] .cu-centerInfo,
html[data-theme="dark"] .cu-ctaInner p {
  color: rgba(248, 250, 252, 0.72);
}

html[data-theme="dark"] .cu-quickCard,
html[data-theme="dark"] .cu-formCard,
html[data-theme="dark"] .cu-right,
html[data-theme="dark"] .cu-map,
html[data-theme="dark"] .cu-centerCard,
html[data-theme="dark"] .cu-cta {
  background: #0b1220;
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.55);
}

html[data-theme="dark"] .cu-mapOverlay,
html[data-theme="dark"] .cu-ctaGlow {
  background: rgba(255, 255, 255, 0.05);
}

html[data-theme="dark"] .cu-quickIcon {
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
}

html[data-theme="dark"] .cu-quickIcon--green {
  background: rgba(22, 163, 74, 0.2);
}

html[data-theme="dark"] .cu-input,
html[data-theme="dark"] .cu-textarea {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

html[data-theme="dark"] .cu-mapBtn {
  background: #7A2A85;
  color: #fff;
}

html[data-theme="dark"] .cu-ctaPrimary {
  background: #fff;
  color: #0b1220;
}

html[data-theme="dark"] .cu-ctaGhost {
  border-color: rgba(255, 255, 255, 0.24);
}

html[data-theme="dark"] .cu-hero {
  color: #f8fafc;
}

html[data-theme="dark"] .cu-quickSmall,
html[data-theme="dark"] .cu-quickBold,
html[data-theme="dark"] .cu-centerName,
html[data-theme="dark"] .cu-tag {
  color: #f1f5ff;
}

html[data-theme="dark"] .cu-mapBg {
  filter: none;
  opacity: 0.7;
}

html[data-theme="dark"] .cu-page::before {
  content: "";
  position: fixed;
  inset: 0;
  background: #02030a;
  z-index: -1;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Contact/contact-us.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,8CAA8C;EAC9C;;AAEF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;;;EAME,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".cu-page {\n  --cu-type-heading: clamp(2.1rem, 2.8vw, 2.8rem);\n  --cu-type-subheading: 1.5rem;\n  --cu-type-card-heading: 1.2rem;\n  --cu-type-body: 1.05rem;\n  --cu-type-label: 0.92rem;\n  --cu-type-cta: 1.02rem;\n  background: #ece4ed;\n  min-height: 100vh;\n  padding: 2.5rem 0 4rem;\n  color: #400C4D;\n}\n\n.cu-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.cu-hero {\n  text-align: center;\n  padding-bottom: 2rem;\n}\n\n.cu-hero__title {\n  font-size: var(--cu-type-heading);\n  font-weight: 800;\n  margin-bottom: 0.5rem;\n  font-family: \"Lexend\", system-ui, sans-serif;\n  color:#400C4D;\n}\n\n.cu-hero__subtitle {\n  margin: 0 auto;\n  max-width: 640px;\n  line-height: 1.6;\n  color: #4a4f65;\n  font-size: var(--cu-type-body);\n}\n\n.cu-quick {\n  margin: 2rem 0 3rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.cu-socialLinks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin: -1.75rem 0 2rem;\n}\n\n.cu-socialLink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 0.9rem;\n  border-radius: 999px;\n  border: 1px solid #400C4D;\n  background: #d6c3d9;\n  color: #400C4D;\n  text-decoration: none;\n  font-weight: 700;\n  font-size: var(--cu-type-label);\n}\n\n.cu-socialLink:hover {\n  background: #f59e0b;\n  border-color: #f59e0b;\n  color: #1f2937;\n  text-decoration: none;\n}\n\n.cu-quickCard {\n  background: #d6c3d9;\n  border-radius: 14px;\n  padding: 1rem 1.15rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: #400C4D;\n  text-decoration: none;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.06);\n  border: 1px solid #400C4D\n\n}\n\n.cu-quickIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #F6EEF8;\n  display: grid;\n  place-items: center;\n  font-size: 1.35rem;\n  color: #400C4D;\n}\n\n.cu-quickIcon--green {\n  background: #ebf7f0;\n  color: #0f9d58;\n}\n\n.cu-quickText {\n  display: flex;\n  flex-direction: column;\n}\n\n.cu-quickSmall {\n  font-size: 0.85rem;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #637094;\n}\n\n.cu-quickBold {\n  font-weight: 700;\n  font-size: 1.08rem;\n}\n\n.cu-quickBold--green {\n  color: #0f9d58;\n}\n\n.cu-main {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 2rem;\n}\n\n.cu-formCard,\n.cu-right {\n  background: #ffffff;\n  border-radius: 18px;\n  padding: 2rem;\n  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.08);\n}\n\n.cu-formHead {\n  margin-bottom: 1.5rem;\n}\n\n.cu-formTitle {\n  margin: 0;\n  font-size: var(--cu-type-subheading);\n  font-weight: 800;\n}\n\n.cu-formSub {\n  margin: 0.4rem 0 0;\n  color: #56617e;\n  font-size: var(--cu-type-body);\n}\n\n.cu-formFallback {\n  margin: 0.5rem 0 0;\n  color: #b91c1c;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.cu-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.cu-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.cu-label {\n  font-size: var(--cu-type-label);\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: #637094;\n}\n\n.cu-input,\n.cu-textarea {\n  border: 1px solid #dfe5f3;\n  border-radius: 12px;\n  padding: 0.85rem 1rem;\n  font-size: var(--cu-type-body);\n  font-family: inherit;\n  transition: border-color 0.2s ease, transform 0.2s ease;\n}\n\n.cu-input:focus,\n.cu-textarea:focus {\n  outline: none;\n  border-color: #400C4D;\n  transform: translateY(-1px);\n}\n\n.cu-textarea {\n  min-height: 160px;\n  resize: vertical;\n}\n\n.cu-row2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.cu-btnPrimary {\n  background: #400C4D;\n  color: #ffffff;\n  border: none;\n  border-radius: 12px;\n  padding: 0.85rem 1.3rem;\n  font-weight: 700;\n  font-size: var(--cu-type-cta);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  justify-content: center;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.cu-btnPrimary--link {\n  text-decoration: none;\n  width: fit-content;\n  margin-top: 0.7rem;\n}\n\n.cu-btnPrimary:hover {\n  transform: translateY(-2px);\n  color: #f59e0b;\n  box-shadow: 0 15px 25px rgba(64, 12, 77, 0.35);\n}\n\n.cu-btnPrimary:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n  transform: none;\n  box-shadow: none;\n}\n\n.cu-sendIcon {\n  font-size: 1rem;\n}\n\n.cu-submitMsg {\n  margin: 0;\n  font-weight: 600;\n}\n\n.cu-submitMsg--success {\n  color: #15803d;\n}\n\n.cu-submitMsg--error {\n  color: #b91c1c;\n}\n\n.cu-right {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.cu-map {\n  border-radius: 18px;\n  box-shadow: 0 25px 40px rgba(15, 23, 42, 0.15);\n  overflow: hidden;\n  padding: 0;\n  background: #fefefe;\n  border: 1px solid rgba(15, 23, 42, 0.05);\n}\n\n.cu-map iframe {\n  width: 100%;\n  border: none;\n  min-height: 220px;\n  display: block;\n}\n\n.cu-mapBtn {\n  background: #400C4D;\n  color: white;\n  border: none;\n  border-radius: 999px;\n  padding: 0.75rem 1.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin: 1rem 1.5rem;\n  align-self: flex-start;\n  transition: background 0.2s ease;\n}\n\n.cu-mapBtn:hover {\n  background: #2A0733;\n}\n\n.cu-centers {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.cu-centersTitle {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-weight: 700;\n  font-size: var(--cu-type-card-heading);\n}\n\n.cu-centerCard {\n  border-radius: 18px;\n  padding: 1.3rem;\n  border: 1px solid #e4e7ef;\n  background: #fdfdfd;\n  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.06);\n}\n\n.cu-centerCard--primary {\n  border-color: rgba(122, 42, 133, 0.35);\n}\n\n.cu-centerCard--accent {\n  border-color: rgba(244, 143, 177, 0.4);\n}\n\n.cu-centerTop {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.9rem;\n}\n\n.cu-centerName {\n  font-weight: 800;\n  font-size: 1.08rem;\n}\n\n.cu-tag {\n  padding: 0.25rem 0.65rem;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n}\n\n.cu-tag--primary {\n  background: rgba(122, 42, 133, 0.12);\n  color: #400C4D;\n}\n\n.cu-tag--accent {\n  background: rgba(244, 143, 177, 0.18);\n  color: #cb1f72;\n}\n\n.cu-infoRow {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 0.4rem;\n  color: #616a85;\n  font-size: var(--cu-type-body);\n}\n\n.cu-infoRow span:first-child {\n  color: #400C4D;\n}\n\n.cu-cta {\n  margin-top: 3rem;\n  position: relative;\n  background: #400C4D;\n  border-radius: 28px;\n  padding: 3rem 1rem 2rem;\n  overflow: hidden;\n  color: #fff;\n  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.35);\n}\n\n.cu-ctaGlow {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  opacity: 0.25;\n}\n\n.cu-ctaGlow--left {\n  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.5), transparent 55%);\n}\n\n.cu-ctaGlow--right {\n  background: radial-gradient(circle at 75% 30%, rgba(255, 255, 255, 0.35), transparent 60%);\n}\n\n.cu-ctaInner {\n  position: relative;\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.cu-ctaInner h2 {\n  margin: 0;\n  font-size: clamp(2rem, 3vw, 2.6rem);\n  font-weight: 900;\n  color: #ffffff;\n}\n\n.cu-ctaInner p {\n  margin: 0.75rem 0 1.5rem;\n  max-width: 600px;\n  line-height: 1.6;\n  color: #ffffff;\n}\n\n.cu-ctaActions {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.cu-ctaPrimary,\n.cu-ctaGhost {\n  border-radius: 999px;\n  padding: 0.9rem 1.8rem;\n  font-weight: 700;\n  font-size: var(--cu-type-cta);\n  cursor: pointer;\n  border: none;\n  transition: transform 0.2s ease;\n}\n\n.cu-ctaPrimary {\n  background: #fff;\n  color: #400C4D;\n}\n\n.cu-ctaGhost {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  color: #fff;\n  text-decoration: none;\n}\n\n.cu-ctaPrimary:hover,\n.cu-ctaGhost:hover {\n  transform: translateY(-2px);\n  color: #f59e0b;\n}\n\n@media (max-width: 1024px) {\n  .cu-main {\n    grid-template-columns: 1fr;\n  }\n  .cu-row2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .cu-spotlight,\n  .cu-ctaInner {\n    padding: 0 1rem;\n  }\n}\n\nhtml[data-theme=\"dark\"] .cu-page {\n  background: #02030a;\n  color: #f8fafc;\n}\n\nhtml[data-theme=\"dark\"] .cu-hero__subtitle,\nhtml[data-theme=\"dark\"] .cu-formSub,\nhtml[data-theme=\"dark\"] .cu-centerInfo,\nhtml[data-theme=\"dark\"] .cu-ctaInner p {\n  color: rgba(248, 250, 252, 0.72);\n}\n\nhtml[data-theme=\"dark\"] .cu-quickCard,\nhtml[data-theme=\"dark\"] .cu-formCard,\nhtml[data-theme=\"dark\"] .cu-right,\nhtml[data-theme=\"dark\"] .cu-map,\nhtml[data-theme=\"dark\"] .cu-centerCard,\nhtml[data-theme=\"dark\"] .cu-cta {\n  background: #0b1220;\n  border-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.55);\n}\n\nhtml[data-theme=\"dark\"] .cu-mapOverlay,\nhtml[data-theme=\"dark\"] .cu-ctaGlow {\n  background: rgba(255, 255, 255, 0.05);\n}\n\nhtml[data-theme=\"dark\"] .cu-quickIcon {\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n}\n\nhtml[data-theme=\"dark\"] .cu-quickIcon--green {\n  background: rgba(22, 163, 74, 0.2);\n}\n\nhtml[data-theme=\"dark\"] .cu-input,\nhtml[data-theme=\"dark\"] .cu-textarea {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\nhtml[data-theme=\"dark\"] .cu-mapBtn {\n  background: #7A2A85;\n  color: #fff;\n}\n\nhtml[data-theme=\"dark\"] .cu-ctaPrimary {\n  background: #fff;\n  color: #0b1220;\n}\n\nhtml[data-theme=\"dark\"] .cu-ctaGhost {\n  border-color: rgba(255, 255, 255, 0.24);\n}\n\nhtml[data-theme=\"dark\"] .cu-hero {\n  color: #f8fafc;\n}\n\nhtml[data-theme=\"dark\"] .cu-quickSmall,\nhtml[data-theme=\"dark\"] .cu-quickBold,\nhtml[data-theme=\"dark\"] .cu-centerName,\nhtml[data-theme=\"dark\"] .cu-tag {\n  color: #f1f5ff;\n}\n\nhtml[data-theme=\"dark\"] .cu-mapBg {\n  filter: none;\n  opacity: 0.7;\n}\n\nhtml[data-theme=\"dark\"] .cu-page::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  background: #02030a;\n  z-index: -1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
